import { default as IcBack } from "../assets/svg/lili/ic_back_arrow.svg";
import { default as IcChevronDown } from "../assets/svg/icons/solid/chevron-down.svg";
import { default as IcChevronLeft } from "../assets/svg/icons/solid/chevron-left.svg";
import { default as IcChevronRight } from "../assets/svg/icons/solid/chevron-right.svg";
import { default as IcClose } from "../assets/svg/icons/solid/times.svg";
import { default as IcDev } from "../assets/svg/icons/solid/dev.svg";
import { default as IcDocument } from "../assets/svg/lili/ic_pdf.svg";
import { default as IcDraw } from "../assets/svg/lili/ic_draw.svg";
import { default as IcFilm } from "../assets/svg/icons/solid/film.svg";
import { default as IcFilter } from "../assets/svg/lili/ic_filter.svg";
import { default as IcHeadphones } from "../assets/svg/lili/ic_audio_book.svg";
import { default as IcLightBulb } from "../assets/svg/lili/ic_light_bulb.svg";
import { default as IcLiliStar } from "../assets/svg/lili/ic_star.svg";
import { default as IcOrigami } from "../assets/svg/lili/ic_origami.svg";
import { default as IcQuoteLeft } from "../assets/svg/icons/solid/quote-left.svg";
import { default as IcQuoteRight } from "../assets/svg/icons/solid/quote-right.svg";
import { default as IcPlay } from "../assets/svg/icons/solid/play.svg";
import { default as IcSearch } from "../assets/svg/lili/ic_search.svg";
import { default as IcStar } from "../assets/svg/lili/ic_star.svg";
import { default as IcTapuscrit } from "../assets/svg/lili/ic_transcript.svg";
import { default as IcPaperclip } from "../assets/svg/icons/solid/paperclip-solid.svg";
import { default as IcTheater } from "../assets/svg/lili/ic_play.svg";
import { default as IcKeyImages } from "../assets/svg/lili/ic_key_images.svg";
import { default as IcPrint } from "../assets/svg/lili/ic_print.svg";
import { default as IcInstagram } from "../assets/svg/icons/regular/instagram.svg";
import { default as IcArobas } from "../assets/svg/icons/solid/at-solid-full.svg";

export { 
    IcArobas,
    IcBack,
    IcChevronDown,
    IcChevronLeft,
    IcChevronRight,
    IcClose,
    IcDev,
    IcDocument,
    IcDraw,
    IcFilm,
    IcFilter,
    IcHeadphones,
    IcInstagram,
    IcKeyImages,
    IcLightBulb,
    IcLiliStar,
    IcOrigami,
    IcQuoteLeft,
    IcQuoteRight,
    IcPaperclip,
    IcPlay,
    IcPrint,
    IcSearch,
    IcStar,
    IcTapuscrit,
    IcTheater
};